/* eslint-disable @typescript-eslint/no-floating-promises */
import {
  createAsyncThunk,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";
import { type RootState } from "../../store";
import { API } from "../../../api/Api";
import { message } from "antd";
import {
  type NetworkType,
  type ChangeNthZoneType,
  type UserType,
  type ZoneCfg,
  type ZoneType,
  type ZoneTypes,
} from "./manageUsersTypes";
import {
  type PaginationParams,
  type PaginationResponse,
} from "../midservice/midserviceTypes";
// import { TelemetryAPI } from "../../../api/TelemetryApi";

export interface ManageUsersState {
  usersList: PaginationResponse<UserType[]>;
  currentPage: number;
  zones: ZoneType[];
  loading: boolean;
  modalOpen: boolean;
  currentUser: UserType | null;
  availableRoles: string[];
  availableZones: Record<string, ZoneCfg>;
}

const initialState: ManageUsersState = {
  usersList: {
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1,
    totalRecord: 0,
    content: [],
  },
  currentPage: 1,
  currentUser: null,
  zones: [],
  loading: false,
  modalOpen: false,
  availableRoles: [],
  availableZones: {},
};

export const getUsersAsync = createAsyncThunk(
  "manageUsers/getUsers",
  async (paginationParams: PaginationParams) => {
    console.log("getUsers");
    const response = await API.getUsersList(paginationParams);
    console.log("responseresponseresponse", response);
    return response.data;
  },
);

export const createUserAsync = createAsyncThunk(
  "manageUsers/createUserAsync",
  async (createUserParams: UserType, { rejectWithValue }) => {
    console.log("getUsers");
    try {
      const response = await API.createUser(createUserParams);
      console.log("responseresponseresponse", response);
      return response.data;
    } catch (error: any) {
      console.log(error);
      if (error?.response?.data?.detail != null) {
        return rejectWithValue(error.response.data.detail);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

export const updateUserAsync = createAsyncThunk(
  "manageUsers/updateUserAsync",
  async (createUserParams: UserType, { rejectWithValue }) => {
    console.log("getUsers");
    try {
      const response = await API.updateUser(createUserParams);
      console.log("responseresponseresponse", response);
      return response.data;
    } catch (error: any) {
      console.log(error);
      if (error?.response?.data?.detail != null) {
        return rejectWithValue(error.response.data.detail);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

export const deleteUserAsync = createAsyncThunk(
  "manageUsers/deleteUserAsync",
  async (userId: number, { rejectWithValue }) => {
    console.log("getUsers");
    try {
      const response = await API.deleteUser(userId);
      console.log("getNetworks resp", response);
      return response.data;
    } catch (error: any) {
      console.log(error);
      if (error?.response?.data?.detail != null) {
        return rejectWithValue(error.response.data.detail);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

// interface NetworkRecord {
//   domain: string
//   networks:
// }

export const getAvailableZonesAsync = createAsyncThunk(
  "manageUsers/getAvailableZonesAsync",
  async (_, { rejectWithValue }) => {
    console.log("getUsers");
    try {
      const response = await API.getAvailableZones();
      console.log("getNetworks resp", response);
      return response.data;
    } catch (error: any) {
      console.log(error);
      if (error?.response?.data?.detail != null) {
        return rejectWithValue(error.response.data.detail);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

export const getAvailableRolesAsync = createAsyncThunk(
  "manageUsers/getAvailableRoles",
  async (_, { rejectWithValue }) => {
    console.log("getUsers");
    try {
      const response = await API.getAvailableRoles();
      console.log("getNetworks resp", response);
      return response.data;
    } catch (error: any) {
      console.log(error);
      if (error?.response?.data?.detail != null) {
        return rejectWithValue(error.response.data.detail);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

export const manageUsersSlice = createSlice({
  name: "manageUsers",
  initialState,
  reducers: {
    setManagedUser: (state, action: PayloadAction<UserType | null>) => {
      state.currentUser = action.payload;
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setModalOpen: (state, action: PayloadAction<boolean>) => {
      state.modalOpen = action.payload;
    },
    addZone: (state, action: PayloadAction<ZoneType>) => {
      state.zones.push(action.payload);
    },
    changeNthZone: (state, action: PayloadAction<ChangeNthZoneType>) => {
      switch (action.payload.key) {
        case "domain":
          state.zones[action.payload.index].domain = action.payload
            .value as string;
          break;
        case "zone":
          state.zones[action.payload.index].zone = action.payload
            .value as NetworkType;
          break;
        case "type":
          state.zones[action.payload.index].type = action.payload
            .value as ZoneTypes;
          break;
        default:
          break;
      }
    },

    deleteNthZone: (state, action: PayloadAction<number>) => {
      state.zones.splice(action.payload, 1);
    },
    setZones: (state, action: PayloadAction<ZoneType[]>) => {
      state.zones = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getUsersAsync.pending, (state) => {})
      .addCase(getUsersAsync.fulfilled, (state, action) => {
        state.usersList = action.payload;
        state.usersList.content = state.usersList.content.map((v: any) => ({
          ...v,
          key: v.id,
        }));
      })
      .addCase(getUsersAsync.rejected, (state, action) => {
        console.log("actionaction", action);
      });

    builder
      .addCase(createUserAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(createUserAsync.fulfilled, (state, action) => {
        state.usersList.content.push(action.payload);
        state.loading = false;
        message.success("Пользователь создан");
        state.modalOpen = false;
      })
      .addCase(createUserAsync.rejected, (state, action) => {
        // console.log('actionaction', action)
        // console.log('actionaction', action.payload)
        message.error(action.payload as string);
        state.loading = false;
      });
    builder
      .addCase(updateUserAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateUserAsync.fulfilled, (state, action) => {
        // state.usersList.content.push(action.payload)

        for (let i = 0; i < state.usersList.content.length; i++) {
          if (state.usersList.content[i].id === action.payload.id) {
            state.usersList.content[i] = action.payload;
            break;
          }
        }
        state.loading = false;
        message.success("Пользователь обновлен");
        state.modalOpen = false;
      })
      .addCase(updateUserAsync.rejected, (state, action) => {
        // console.log('actionaction', action)
        // console.log('actionaction', action.payload)
        message.error(action.payload as string);
        state.loading = false;
      });
    builder
      .addCase(getAvailableZonesAsync.fulfilled, (state, action) => {
        // state.usersList.content.push(action.payload)

        state.availableZones = action.payload;
      })
      .addCase(getAvailableZonesAsync.rejected, (state, action) => {
        message.error(action.payload as string);
        state.loading = false;
      });
    builder
      .addCase(getAvailableRolesAsync.fulfilled, (state, action) => {
        state.availableRoles = action.payload;
      })
      .addCase(getAvailableRolesAsync.rejected, (state, action) => {
        message.error(action.payload as string);
      });

    builder
      .addCase(deleteUserAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteUserAsync.fulfilled, (state, action) => {
        // state.usersList.content.push(action.payload)

        state.usersList.content = state.usersList.content.filter(
          (user) => user.id !== action.payload,
        );
        state.loading = false;
        message.success("Пользователь удален");
      })
      .addCase(deleteUserAsync.rejected, (state, action) => {
        message.error(action.payload as string);
        state.loading = false;
      });
  },
});

export const selectUsersList = (
  state: RootState,
): PaginationResponse<UserType[]> => state.manageUsers.usersList;

export const selectUsersCurrentPage = (state: RootState): number =>
  state.manageUsers.currentPage;

export const selectManageZones = (state: RootState): ZoneType[] =>
  state.manageUsers.zones;

export const selectLoading = (state: RootState): boolean =>
  state.manageUsers.loading;

export const selectModalOpen = (state: RootState): boolean =>
  state.manageUsers.modalOpen;

export const selectCurrentUser = (state: RootState): UserType | null =>
  state.manageUsers.currentUser;

export const selectAvailableRoles = (state: RootState): string[] =>
  state.manageUsers.availableRoles;

export const selectAvailableZones = (
  state: RootState,
): Record<string, ZoneCfg> => state.manageUsers.availableZones;

export const {
  setCurrentPage,
  addZone,
  changeNthZone,
  setModalOpen,
  setManagedUser,
  setZones,
  deleteNthZone,
} = manageUsersSlice.actions;

export default manageUsersSlice.reducer;
